import type { CSSProperties } from 'react';

/**
 * Card grid for micro surfaces (listing page, grid block, rail's grid
 * mode). A SHORTS-only surface gets the legacy "shorts-reel" layout —
 * narrow columns for the 9:16 portrait cards, packed from the left —
 * while every other kind keeps the standard responsive grid.
 */
export function microCardGridStyle(kind: string | undefined): CSSProperties {
  if (kind === 'SHORTS') {
    return {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 200px))',
      gap: 'clamp(12px, 2vw, 16px)',
      justifyContent: 'flex-start',
    };
  }
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(240px, 100%), 1fr))',
    gap: 'clamp(12px, 2vw, 16px)',
  };
}
